import { Grid } from "@mui/material"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useState, useCallback } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getLeagueListAction, getLeagueDataAction, publishLeagueAction } from "redux/DMV/actions"
import { DMVActions } from "redux/DMV/slice/user"
import AddNewLeagueForm from "./components/addNewLeagueForm"
import ContestListTable from "./components/ContestListTable"
import { leagueColumns } from "helpers/constant"

const LeagueManagement = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { league } = useSelector((store) => store?.dmv)
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [open, setOpen] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(10)

  const fetchLeagues = useCallback(
    (page) => {
      dispatch(
        getLeagueListAction({
          page: page,
          page_size: pageSize
        })
      )
    },
    [pageSize]
  )

  useEffect(() => {
    document.title = "Leagues"
    setBreadcrumbs(createBreadcrumbs())
    fetchLeagues(currentPage)
    dispatch(DMVActions.initLeague())
  }, [currentPage])

  useEffect(() => {
    if (league?.isLeagueFormSubmitted) {
      setCurrentPage(1)
      fetchLeagues(1)
      dispatch(DMVActions.setIsLeagueFormSubmitted(false))
    }
  }, [league?.isLeagueFormSubmitted])

  const handlePageChange = (page) => {
    setCurrentPage(page)
    fetchLeagues(page)
  }

  const handleView = (contest) => {
    history.push(`/dmv/dashboard/leagues/view`)
    dispatch(getLeagueDataAction({ leagueId: contest.id }))
  }

  const handleEdit = (contest) => {
    setIsEdit(true)
    dispatch(DMVActions.setLeagueId(contest?.id))
    setOpen(true)
  }

  const handlePublish = (contest) => {
    if (window.confirm(`Are you sure you want to publish "${contest.name || contest.podName}"?`)) {
      dispatch(
        publishLeagueAction({
          leagueId: contest.id,
          onSuccess: () => {
            history.push(`/dmv/dashboard/leagues`)
          }
        })
      )
    }
  }
  const onClose = () => {
    setOpen(false)
    setIsEdit(false)
  }

  useEffect(() => {
    if (league?.isLeagueFormSubmitted) {
      onClose()
    }
  }, [league?.isLeagueFormSubmitted])

  return (
    <>
      <AddNewLeagueForm
        open={open}
        onClose={() => {
          onClose()
        }}
        isEdit={isEdit}
      />
      <Grid container className="p-0">
        <Grid item xs={12}>
          <Header title={"Leagues"} breadCrumbs={breadCrumbs}>
            <AppButton
              onClick={() => {
                dispatch(DMVActions.setLeagueId(null))
                dispatch(DMVActions.setLeagueData({}))
                setOpen(true)
              }}
              styles={{ padding: "12px 20px" }}>
              + Add New League
            </AppButton>
          </Header>
        </Grid>

        <Container style={{ minWidth: "100%" }}>
          <Row style={{ width: "100%", overflow: "auto" }}>
            <Col lg="12" className="p-0">
              <ContestListTable
                setPage={handlePageChange}
                currentPage={currentPage}
                totalPage={league?.pagination?.totalPages || 1}
                pageSize={pageSize}
                rows={league?.leagueList || []}
                columns={leagueColumns}
                onView={handleView}
                onEdit={handleEdit}
                onPublish={handlePublish}
              />
            </Col>
          </Row>
        </Container>
      </Grid>
    </>
  )
}

export default LeagueManagement
